import React from 'react';

function About() {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl md:text-4xl font-medium text-gray-900 mb-8 pb-4 border-b-2" style={{ borderColor: '#667eea' }}>
        About Ankerit
      </h1>
      
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-medium mb-4" style={{ color: '#667eea' }}>What is Ankerit?</h2>
          <p className="text-base leading-relaxed" style={{ color: '#2c3e50' }}>
            Ankerit is the first innovative B2B SaaS search engine and EASPM (External Attack Surface Management) 
            cloud-based platform. We provide comprehensive search capabilities for discovering and analyzing cloud assets 
            across major cloud providers covering your attack surface.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-medium mb-4" style={{ color: '#667eea' }}>Our Mission</h2>
          <p className="text-base leading-relaxed" style={{ color: '#2c3e50' }}>
            We are pioneering the field of B2B SaaS discovery and cloud asset management. Our platform enables security 
            professionals, researchers, and organizations to search and analyze cloud infrastructure data, including SSL/TLS 
            certificates and B2B SaaS platform usage.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-medium mb-4" style={{ color: '#667eea' }}>Key Features</h2>
          <ul className="space-y-3 list-disc list-inside text-base leading-relaxed" style={{ color: '#2c3e50' }}>
            <li>
              <strong className="font-medium" style={{ color: '#2c3e50' }}>Cloud Asset Search:</strong> Search for actual and historical data on cloud assets from AWS and GCP
            </li>
            <li>
              <strong className="font-medium" style={{ color: '#2c3e50' }}>B2B SaaS Discovery:</strong> First-of-its-kind search engine for discovering B2B SaaS platform usage
            </li>
            <li>
              <strong className="font-medium" style={{ color: '#2c3e50' }}>EASPM Platform:</strong> Cloud-based External Attack Surface Management solution
            </li>
            <li>
              <strong className="font-medium" style={{ color: '#2c3e50' }}>Certificate Analysis:</strong> Comprehensive SSL/TLS certificate search and analysis
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-medium mb-4" style={{ color: '#667eea' }}>Innovation</h2>
          <p className="text-base leading-relaxed" style={{ color: '#2c3e50' }}>
            Ankerit represents a breakthrough in the field of external attack surface management. As the first B2B SaaS 
            search engine, we provide unique insights into how organizations use various SaaS platforms, helping security 
            teams understand their external footprint and potential attack vectors covering shadow IT.
          </p>
        </section>

        <section className="rounded-lg p-6 border-l-4" style={{ backgroundColor: 'rgba(102, 126, 234, 0.1)', borderColor: '#667eea' }}>
          <h2 className="text-2xl font-medium mb-4" style={{ color: '#667eea' }}>🔔 Alerting Service</h2>
          <p className="text-base leading-relaxed mb-4" style={{ color: '#2c3e50' }}>
            Stay informed about new SaaS platform discoveries for your company keywords. Our alerting system 
            automatically notifies you when new services are detected for monitored company keywords.
          </p>
          <div className="bg-white rounded p-4 mb-4">
            <h3 className="font-semibold mb-2" style={{ color: '#2c3e50' }}>Features:</h3>
            <ul className="list-disc list-inside space-y-2" style={{ color: '#2c3e50' }}>
              <li>Real-time notifications when new SaaS platforms are discovered</li>
              <li>Monitor multiple company keywords simultaneously</li>
              <li>Email alerts with detailed information about new discoveries</li>
              <li>Track shadow IT and unauthorized SaaS usage</li>
            </ul>
          </div>
          <p className="text-sm" style={{ color: '#555' }}>
            Contact us at <a href="mailto:service@ankerit.io" className="font-medium hover:opacity-80 transition-opacity" style={{ color: '#667eea' }}>service@ankerit.io</a> to set up alerting for your organization.
          </p>
        </section>

        <section className="rounded-lg p-6 border-l-4" style={{ backgroundColor: 'rgba(118, 75, 162, 0.1)', borderColor: '#764ba2' }}>
          <h2 className="text-2xl font-medium mb-4" style={{ color: '#764ba2' }}>🔌 API Access</h2>
          <p className="text-base leading-relaxed mb-4" style={{ color: '#2c3e50' }}>
            Integrate Ankerit's powerful search capabilities directly into your applications and workflows 
            with our comprehensive REST API.
          </p>
          <div className="bg-white rounded p-4 mb-4">
            <h3 className="font-semibold mb-2" style={{ color: '#2c3e50' }}>API Endpoints:</h3>
            <div className="space-y-3 text-sm font-mono">
              <div className="bg-gray-50 p-3 rounded">
                <div className="font-semibold mb-1" style={{ color: '#764ba2' }}>GET /api/search</div>
                <div style={{ color: '#555' }}>Search SSL/TLS certificates</div>
              </div>
              <div className="bg-gray-50 p-3 rounded">
                <div className="font-semibold mb-1" style={{ color: '#764ba2' }}>GET /api/search/b2bsaas</div>
                <div style={{ color: '#555' }}>Search B2B SaaS platform usage</div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded p-4 mb-4">
            <h3 className="font-semibold mb-2" style={{ color: '#2c3e50' }}>Authentication:</h3>
            <p className="text-sm mb-2" style={{ color: '#2c3e50' }}>
              All API requests require authentication using JWT tokens. Contact service@ankerit.io to get your API access token.
            </p>
            <div className="bg-gray-50 p-3 rounded text-xs font-mono" style={{ color: '#2c3e50' }}>
              Authorization: Bearer YOUR_JWT_TOKEN
            </div>
          </div>
          <div className="bg-white rounded p-4 mb-4">
            <h3 className="font-semibold mb-2" style={{ color: '#2c3e50' }}>Rate Limits:</h3>
            <ul className="list-disc list-inside space-y-1 text-sm" style={{ color: '#2c3e50' }}>
              <li>Free users: 3 requests per day</li>
              <li>Premium users: Unlimited requests</li>
            </ul>
          </div>
          <p className="text-sm" style={{ color: '#555' }}>
            For API documentation and access, contact us at <a href="mailto:service@ankerit.io" className="font-medium hover:opacity-80 transition-opacity" style={{ color: '#764ba2' }}>service@ankerit.io</a>
          </p>
        </section>

        <section className="rounded-lg p-6 border-l-4" style={{ backgroundColor: 'rgba(102, 126, 234, 0.1)', borderColor: '#667eea' }}>
          <h2 className="text-2xl font-medium mb-4" style={{ color: '#667eea' }}>Contact Us</h2>
          <p className="text-base leading-relaxed mb-2" style={{ color: '#2c3e50' }}>
            For feedback, questions, or inquiries, please contact us at:
          </p>
          <p className="mb-4">
            <a 
              href="mailto:service@ankerit.io"
              className="font-medium transition-opacity duration-200 underline decoration-2 underline-offset-2 hover:opacity-80"
              style={{ color: '#667eea' }}
            >
              service@ankerit.io
            </a>
          </p>
          <p className="text-sm italic" style={{ color: '#555' }}>
            We welcome your feedback and suggestions to help us improve our platform.
          </p>
        </section>
      </div>
    </div>
  );
}

export default About;

